import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import { CustomDialog } from "./CustomDialog";
import { DialogHeader } from "./DialogHeader";

export default function TermsAndConditionsModal(props: {
  open: boolean;
  setOpen: (showModal: boolean) => void;
  acceptTerms: () => void;
}) {
  const { open, setOpen, acceptTerms } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <CustomDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader id="customized-dialog-title" onClose={handleClose}>
        Termos e Condições
      </DialogHeader>
      <DialogContent dividers>
        <div style={{ margin: "20px" }}>
          <Typography gutterBottom>
            Antes de prosseguir, é importante que você leia e aceite nossos{" "}
            <a target="blank" href="#">
              termos e condições
            </a>
            . Eles contêm informações importantes sobre o uso deste serviço.
            Certifique-se de ler atentamente o documento antes de prosseguir.
          </Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="error" variant="contained" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="contained" onClick={acceptTerms}>
          Aceitar
        </Button>
      </DialogActions>
    </CustomDialog>
  );
}
